import { Link } from "@/i18n/i18n-navigation";
import * as React from "react";

interface ProductLinkProps {
  handle: string;
  children?: React.ReactNode;
}

export const ProductLink: React.FC<ProductLinkProps> = ({
  children,
  handle,
}) => {
  return (
    <Link href={`/product/all/${handle}`} passHref>
      {children}
    </Link>
  );
};
